import { useEffect, useState } from "react";
import { adminApi, apiError } from "@/admin/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

export default function Settings() {
  const [s, setS] = useState(null);

  useEffect(() => { adminApi.get("/admin/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <div className="text-gray-400">Loading…</div>;

  const set = (k, v) => setS({ ...s, [k]: v });
  const setSocial = (k, v) => setS({ ...s, social: { ...(s.social || {}), [k]: v } });
  const setDon = (k, v) => setS({ ...s, donation: { ...(s.donation || {}), [k]: v } });

  const save = async () => {
    try { await adminApi.put("/admin/settings", { data: s }); toast.success("Settings saved"); }
    catch (e) { toast.error(apiError(e)); }
  };

  const Text = ({ k, label, val, on }) => (
    <div><label className="text-xs font-semibold text-gray-500 uppercase">{label}</label>
      <input data-testid={`set-${k}`} value={val ?? ""} onChange={(e) => on(k, e.target.value)} className="w-full mt-1 py-2 px-3 rounded-lg border border-gray-300 text-sm" /></div>
  );

  const d = s.donation || {};

  return (
    <div className="space-y-6 max-w-3xl">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold text-gray-900">Website Settings</h1>
        <button data-testid="settings-save" onClick={save} className="inline-flex items-center gap-2 rounded-lg bg-[hsl(13_65%_54%)] text-white px-4 py-2 text-sm font-medium"><Save size={15} /> Save</button>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-6 grid sm:grid-cols-2 gap-4">
        <Text k="site_name" label="Website Name" val={s.site_name} on={set} />
        <Text k="contact_email" label="Contact Email" val={s.contact_email} on={set} />
        <Text k="phone" label="Phone" val={s.phone} on={set} />
        <Text k="whatsapp" label="WhatsApp" val={s.whatsapp} on={set} />
        <Text k="address" label="Address" val={s.address} on={set} />
        <Text k="logo" label="Logo URL" val={s.logo} on={set} />
        <Text k="seo_title" label="SEO Title" val={s.seo_title} on={set} />
        <Text k="seo_description" label="SEO Description" val={s.seo_description} on={set} />
        <Text k="ngo_darpan_id" label="NGO Darpan Unique ID (optional)" val={s.ngo_darpan_id} on={set} />
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <h2 className="font-semibold text-gray-800 mb-4">Social Links</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          {["facebook", "instagram", "twitter", "youtube"].map((k) => (
            <div key={k}><label className="text-xs font-semibold text-gray-500 uppercase">{k}</label>
              <input value={s.social?.[k] || ""} onChange={(e) => setSocial(k, e.target.value)} className="w-full mt-1 py-2 px-3 rounded-lg border border-gray-300 text-sm" /></div>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <h2 className="font-semibold text-gray-800 mb-4">Donation Page Settings</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><label className="text-xs font-semibold text-gray-500 uppercase">Suggested Amounts (comma separated)</label>
            <input data-testid="set-suggested" value={(d.suggested_amounts || []).join(", ")}
              onChange={(e) => setDon("suggested_amounts", e.target.value.split(",").map((x) => Number(x.trim())).filter(Boolean))}
              className="w-full mt-1 py-2 px-3 rounded-lg border border-gray-300 text-sm" /></div>
          <div><label className="text-xs font-semibold text-gray-500 uppercase">Description</label>
            <input value={d.description || ""} onChange={(e) => setDon("description", e.target.value)} className="w-full mt-1 py-2 px-3 rounded-lg border border-gray-300 text-sm" /></div>
          <div><label className="text-xs font-semibold text-gray-500 uppercase">Min Amount</label>
            <input type="number" value={d.min_amount ?? 100} onChange={(e) => setDon("min_amount", Number(e.target.value))} className="w-full mt-1 py-2 px-3 rounded-lg border border-gray-300 text-sm" /></div>
          <div><label className="text-xs font-semibold text-gray-500 uppercase">Max Amount</label>
            <input type="number" value={d.max_amount ?? 500000} onChange={(e) => setDon("max_amount", Number(e.target.value))} className="w-full mt-1 py-2 px-3 rounded-lg border border-gray-300 text-sm" /></div>
        </div>
        <div className="flex flex-wrap gap-4 mt-4">
          {[["allow_custom", "Custom amount"], ["allow_anonymous", "Anonymous donations"], ["require_name", "Require name"], ["require_email", "Require email"], ["require_phone", "Require phone"]].map(([k, l]) => (
            <label key={k} className="inline-flex items-center gap-2 text-sm text-gray-700">
              <input type="checkbox" checked={!!d[k]} onChange={(e) => setDon(k, e.target.checked)} /> {l}
            </label>
          ))}
        </div>
      </div>

      <label className="inline-flex items-center gap-2 text-sm text-gray-700">
        <input type="checkbox" checked={!!s.maintenance} onChange={(e) => set("maintenance", e.target.checked)} /> Maintenance mode (public site shows a maintenance notice)
      </label>
    </div>
  );
}
